// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --profile-primary: #201157;
  --profile-primary-text: #ffffff;
  --profile-primary-dark: #201157;
  --profile-accent: #EB266A;
  --profile-name-color: #201157;
  --profile-body-color: #555;
  --profile-card-bg: #f5f5fa;
  --profile-bg: #f6f3ff;
  --profile-btn-bg: #201157;
  --profile-btn-text: #ffffff;
  --profile-ring-color: #201157;
}

::ng-deep ion-content {
  --background: #ffffff;
}

ion-toolbar {
  --border-width: 0 !important;
  border-bottom: none;
}

ion-title p {
  font-weight: 600;
  font-size: 17px;
  margin: 0;
}

.txt-edit-profile {
  display: none;
}

.badge-header {
  padding: 24px 20px 8px;
  text-align: center;
}

.avatar-frame {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 16px;
  border-radius: 50%;
  padding: 5px;
  background: var(--profile-ring-color);
  box-shadow: 0 0 0 3px var(--profile-ring-color), 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.avatar-frame:hover {
  transform: scale(1.03);
  box-shadow: 0 0 0 3px var(--profile-ring-color), 0 12px 40px rgba(0, 0, 0, 0.15);
}
.avatar-frame ion-avatar {
  width: 100%;
  height: 100%;
  margin: 0;
}
.avatar-frame .avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
.avatar-frame .avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--profile-card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-frame .avatar-placeholder ion-icon {
  width: 52px;
  height: 52px;
  opacity: 0.25;
  color: var(--profile-primary);
}

.profile-name {
  font-size: 28px;
  font-weight: 700;
  color: var(--profile-name-color);
  margin: 0 0 4px;
  line-height: 1.2;
  letter-spacing: -0.3px;
  word-break: break-word;
}

.profile-role {
  font-size: 16px;
  font-weight: 400;
  color: var(--profile-body-color);
  margin: 0 0 16px;
  opacity: 0.8;
  line-height: 1.4;
  word-break: break-word;
}

.social-row {
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}
.social-row .social-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
}
.social-row .social-btn:hover {
  transform: scale(1.15);
  background: color-mix(in srgb, var(--profile-primary) 10%, transparent);
}
.social-row .social-btn ion-icon {
  width: 20px;
  height: 20px;
  color: var(--profile-primary);
}

.content-body {
  padding: 4px 20px 32px;
  max-width: 640px;
  margin: 0 auto;
  animation: fadeInUp 0.4s ease both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.profile-section {
  margin-top: 28px;
}
.profile-section:first-child {
  margin-top: 0;
}

.section-title {
  --section-title-color: var(--profile-body-color);
}

.section-content {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.description-text {
  font-size: 15px;
  line-height: 1.65;
  color: var(--profile-body-color);
  font-weight: 400;
}
.description-text * {
  max-width: 100%;
  word-break: break-word;
}

.fields-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;
}

.field-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.field-item .field-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: var(--profile-primary);
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.field-item i.field-icon {
  font-size: 20px;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}
.field-item .field-text {
  flex: 1;
  min-width: 0;
}
.field-item .field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--profile-body-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
  opacity: 0.6;
}
.field-item .field-value {
  font-size: 15px;
  line-height: 1.4;
  color: var(--profile-name-color);
  font-weight: 500;
  word-break: break-word;
}

.documents-list {
  display: flex;
  flex-direction: column;
}

.doc-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.2s ease;
  border-radius: 12px;
}
.doc-item:hover {
  background: var(--profile-card-bg);
}
.doc-item + .doc-item {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.doc-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: var(--profile-card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}
.doc-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.doc-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.doc-name {
  font-size: 15px;
  font-weight: 500;
  color: var(--profile-name-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doc-type {
  font-size: 12px;
  font-weight: 400;
  color: var(--profile-body-color);
  opacity: 0.6;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 28px;
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 18px 8px 14px;
  border-radius: 16px;
  border: none;
  background: var(--profile-card-bg);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  background: color-mix(in srgb, var(--profile-card-bg) 90%, white);
}
.action-btn:active {
  transform: translateY(0);
}
.action-btn ion-icon {
  font-size: 24px;
  color: var(--profile-primary);
}
.action-btn .action-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--profile-body-color);
  text-align: center;
  line-height: 1.2;
  max-width: 100%;
  word-break: break-word;
}
.action-btn--danger ion-icon {
  color: var(--ion-color-danger, #f04141);
}
.action-btn--danger .action-label {
  color: var(--ion-color-danger, #f04141);
}

.align-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

@media screen and (min-width: 768px) {
  ::ng-deep ion-content {
    --background: var(--profile-bg);
  }
  .badge-header {
    padding: 40px 20px 16px;
  }
  .avatar-frame {
    width: 140px;
    height: 140px;
  }
  .avatar-frame .avatar-placeholder ion-icon {
    width: 60px;
    height: 60px;
  }
  .profile-name {
    font-size: 36px;
  }
  .profile-role {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .social-row {
    gap: 8px;
  }
  .social-row .social-btn {
    width: 42px;
    height: 42px;
  }
  .social-row .social-btn ion-icon {
    width: 22px;
    height: 22px;
  }
  .content-body {
    padding: 8px 20px 48px;
  }
  .actions-grid {
    grid-template-columns: repeat(6, 1fr);
    gap: 10px;
  }
  .action-btn {
    padding: 16px 8px 12px;
  }
  .action-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .content-body {
    animation: none;
  }
  .avatar-frame,
  .action-btn,
  .social-btn,
  .doc-item {
    transition: none !important;
  }
  .avatar-frame:hover,
  .action-btn:hover,
  .social-btn:hover,
  .doc-item:hover {
    transform: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/personal-page/personal-page.page.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,+BAAA;EACA,+BAAA;EACA,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,0BAAA;EACA,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,4BAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qCAAA;EACA,8EACE;EAEF,qDAAA;AADF;AAGE;EACE,sBAAA;EACA,gFACE;AAFN;AAME;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANJ;AAQI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;AANN;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AARF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AARF;AAUE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;AARJ;AAUI;EACE,sBAAA;EACA,uEAAA;AARN;AAWI;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AATN;;AAcA;EACE,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAXF;;AAcA;EACE;IACE,UAAA;IACA,2BAAA;EAXF;EAaA;IACE,UAAA;IACA,wBAAA;EAXF;AACF;AAcA;EACE,gBAAA;AAZF;AAcE;EACE,aAAA;AAZJ;;AAgBA;EACE,gDAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,qCAAA;AAbF;;AAgBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;AAbF;AAeE;EACE,eAAA;EACA,sBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAdF;AAgBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfJ;AAkBE;EACE,OAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,sBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,kCAAA;AAnBJ;AAsBE;EACE,yCAAA;AApBJ;;AAwBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArBF;AAuBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AArBJ;;AAyBA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;EACA,2EAAA;AAtBF;AAwBE;EACE,2BAAA;EACA,0CAAA;EACA,iEAAA;AAtBJ;AAyBE;EACE,wBAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,6BAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAzBJ;AA6BI;EACE,uCAAA;AA3BN;AA8BI;EACE,uCAAA;AA5BN;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE;IACE,+BAAA;EA9BF;EAiCA;IACE,uBAAA;EA/BF;EAkCA;IACE,YAAA;IACA,aAAA;EAhCF;EAkCE;IACE,WAAA;IACA,YAAA;EAhCJ;EAoCA;IACE,eAAA;EAlCF;EAqCA;IACE,eAAA;IACA,mBAAA;EAnCF;EAsCA;IACE,QAAA;EApCF;EAsCE;IACE,WAAA;IACA,YAAA;EApCJ;EAsCI;IACE,WAAA;IACA,YAAA;EApCN;EAyCA;IACE,sBAAA;EAvCF;EA0CA;IACE,qCAAA;IACA,SAAA;EAxCF;EA2CA;IACE,sBAAA;EAzCF;EA2CE;IACE,2BAAA;IACA,yCAAA;EAzCJ;AACF;AA6CA;EACE;IACE,eAAA;EA3CF;EA8CA;;;;IAIE,2BAAA;EA5CF;EA8CE;;;;IACE,0BAAA;EAzCJ;AACF","sourcesContent":[":host {\n  --profile-primary: #201157;\n  --profile-primary-text: #ffffff;\n  --profile-primary-dark: #201157;\n  --profile-accent: #EB266A;\n  --profile-name-color: #201157;\n  --profile-body-color: #555;\n  --profile-card-bg: #f5f5fa;\n  --profile-bg: #f6f3ff;\n  --profile-btn-bg: #201157;\n  --profile-btn-text: #ffffff;\n  --profile-ring-color: #201157;\n}\n\n::ng-deep ion-content {\n  --background: #ffffff;\n}\n\nion-toolbar {\n  --border-width: 0 !important;\n  border-bottom: none;\n}\n\nion-title p {\n  font-weight: 600;\n  font-size: 17px;\n  margin: 0;\n}\n\n.txt-edit-profile {\n  display: none;\n}\n\n.badge-header {\n  padding: 24px 20px 8px;\n  text-align: center;\n}\n\n.avatar-frame {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  margin: 0 auto 16px;\n  border-radius: 50%;\n  padding: 5px;\n  background: var(--profile-ring-color);\n  box-shadow:\n    0 0 0 3px var(--profile-ring-color),\n    0 8px 32px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n  &:hover {\n    transform: scale(1.03);\n    box-shadow:\n      0 0 0 3px var(--profile-ring-color),\n      0 12px 40px rgba(0, 0, 0, 0.15);\n  }\n\n  ion-avatar {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n  }\n\n  .avatar-img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n    cursor: pointer;\n  }\n\n  .avatar-placeholder {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background: var(--profile-card-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ion-icon {\n      width: 52px;\n      height: 52px;\n      opacity: 0.25;\n      color: var(--profile-primary);\n    }\n  }\n}\n\n.profile-name {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--profile-name-color);\n  margin: 0 0 4px;\n  line-height: 1.2;\n  letter-spacing: -0.3px;\n  word-break: break-word;\n}\n\n.profile-role {\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--profile-body-color);\n  margin: 0 0 16px;\n  opacity: 0.8;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.social-row {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n  flex-wrap: wrap;\n\n  .social-btn {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: transform 0.2s ease, background 0.2s ease;\n\n    &:hover {\n      transform: scale(1.15);\n      background: color-mix(in srgb, var(--profile-primary) 10%, transparent);\n    }\n\n    ion-icon {\n      width: 20px;\n      height: 20px;\n      color: var(--profile-primary);\n    }\n  }\n}\n\n.content-body {\n  padding: 4px 20px 32px;\n  max-width: 640px;\n  margin: 0 auto;\n  animation: fadeInUp 0.4s ease both;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.profile-section {\n  margin-top: 28px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n}\n\n.section-title {\n  --section-title-color: var(--profile-body-color);\n}\n\n.section-content {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.description-text {\n  font-size: 15px;\n  line-height: 1.65;\n  color: var(--profile-body-color);\n  font-weight: 400;\n\n  * {\n    max-width: 100%;\n    word-break: break-word;\n  }\n}\n\n.fields-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 20px;\n}\n\n.field-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n\n  .field-icon {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    font-size: 20px;\n    color: var(--profile-primary);\n    margin-top: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  i.field-icon {\n    font-size: 20px;\n    font-style: normal;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .field-text {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .field-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--profile-body-color);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 2px;\n    opacity: 0.6;\n  }\n\n  .field-value {\n    font-size: 15px;\n    line-height: 1.4;\n    color: var(--profile-name-color);\n    font-weight: 500;\n    word-break: break-word;\n  }\n}\n\n.documents-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.doc-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 20px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  border-radius: 12px;\n\n  &:hover {\n    background: var(--profile-card-bg);\n  }\n\n  + .doc-item {\n    border-top: 1px solid rgba(0, 0, 0, 0.05);\n  }\n}\n\n.doc-icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: var(--profile-card-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n  }\n}\n\n.doc-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.doc-name {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--profile-name-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.doc-type {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--profile-body-color);\n  opacity: 0.6;\n}\n\n.actions-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-top: 28px;\n}\n\n.action-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 18px 8px 14px;\n  border-radius: 16px;\n  border: none;\n  background: var(--profile-card-bg);\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    background: color-mix(in srgb, var(--profile-card-bg) 90%, white);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  ion-icon {\n    font-size: 24px;\n    color: var(--profile-primary);\n  }\n\n  .action-label {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--profile-body-color);\n    text-align: center;\n    line-height: 1.2;\n    max-width: 100%;\n    word-break: break-word;\n  }\n\n  &--danger {\n    ion-icon {\n      color: var(--ion-color-danger, #f04141);\n    }\n\n    .action-label {\n      color: var(--ion-color-danger, #f04141);\n    }\n  }\n}\n\n.align-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n@media screen and (min-width: 768px) {\n  ::ng-deep ion-content {\n    --background: var(--profile-bg);\n  }\n\n  .badge-header {\n    padding: 40px 20px 16px;\n  }\n\n  .avatar-frame {\n    width: 140px;\n    height: 140px;\n\n    .avatar-placeholder ion-icon {\n      width: 60px;\n      height: 60px;\n    }\n  }\n\n  .profile-name {\n    font-size: 36px;\n  }\n\n  .profile-role {\n    font-size: 18px;\n    margin-bottom: 20px;\n  }\n\n  .social-row {\n    gap: 8px;\n\n    .social-btn {\n      width: 42px;\n      height: 42px;\n\n      ion-icon {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  .content-body {\n    padding: 8px 20px 48px;\n  }\n\n  .actions-grid {\n    grid-template-columns: repeat(6, 1fr);\n    gap: 10px;\n  }\n\n  .action-btn {\n    padding: 16px 8px 12px;\n\n    &:hover {\n      transform: translateY(-3px);\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .content-body {\n    animation: none;\n  }\n\n  .avatar-frame,\n  .action-btn,\n  .social-btn,\n  .doc-item {\n    transition: none !important;\n\n    &:hover {\n      transform: none !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
